var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonDt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84257 8.052C5.73486 8.052 3.21543 5.74226 3.21543 2.89457C3.21543 1.82024 3.57343 0.825262 4.18514 0C1.75229 0.756119 0 2.86498 0 5.35045C0 8.47079 2.75943 11 6.16286 11C8.87429 11 11.1757 9.39452 12 7.16362C11.1 7.72383 10.0129 8.052 8.84257 8.052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonDt);
export default __webpack_public_path__ + "static/media/moon-dt.669a6e50fdca0ac668b67299ab296399.svg";
export { ForwardRef as ReactComponent };